import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_FLASHCARD + '/flashcard-lesson-item'

const fetch = (params) => {
  return Repository(baseURL).fetch(params)
}

const fetchOne = (id) => {
  return Repository(baseURL).fetchOne(id)
}

const create = (params) => {
  return Repository(baseURL).create(params)
}

const createMany = (params) => {
  return Repository(baseURL).createMany(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

export default {
  update,
  create,
  fetch,
  fetchOne,
  createMany
}
